import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "감사의 말",
  "description": "지원과 도움을 주신 모든 개발자, 빌드 시스템 및 monorepo 도구에 감사드립니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo는 원래 Jared Palmer가 비공개 소스 엔터프라이즈 소프트웨어로 만들었습니다. 2021년 말, Vercel이 Turborepo를 인수하고 코드베이스를 오픈 소스화했습니다."
  }, {
    "heading": "",
    "content": "현재 Turborepo는 전담 풀타임 팀이 작업하고 있으며, 점점 늘어나는 오픈 소스 기여자 목록을 보유하고 있습니다."
  }, {
    "heading": "영감과-선행-기술",
    "content": "Vercel에서는 오픈 소스 운동과 오픈 협업의 힘을 깊이 믿고 있습니다. 이를 위해 우리와 우리의 작업에 영감을 준 프로젝트와 사람들에게 의미 있는 공로를 인정하는 것이 중요합니다."
  }, {
    "heading": "영감과-선행-기술",
    "content": "다른 빌드 시스템, monorepo 도구 및 선행 기술에 특별히 감사드립니다:"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Bazel - https://bazel.build"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Buck - https://buck.build"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Please - https://please.build"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Pants - https://www.pantsbuild.org"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Scoot - https://github.com/twitter/scoot"
  }, {
    "heading": "영감과-선행-기술",
    "content": "TSDX - https://tsdx.io"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Lerna - https://lerna.js.org"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Lage - https://microsoft.github.io/lage"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Backfill - https://github.com/microsoft/backfill"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Bolt - https://github.com/boltpkg/bolt"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Rush - https://rushjs.io"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Preconstruct - https://preconstruct.tools"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Nx - https://nx.dev"
  }, {
    "heading": "영감과-선행-기술",
    "content": "Yarn - https://yarnpkg.com"
  }, {
    "heading": "영감과-선행-기술",
    "content": "npm - https://www.npmjs.com"
  }, {
    "heading": "영감과-선행-기술",
    "content": "pnpm - https://pnpm.js.org"
  }, {
    "heading": "영감과-선행-기술",
    "content": "문서 전반에 걸쳐 해당되는 경우, 우리에게 영감을 준 프로젝트와 사람들에 대한 인라인 설명과 링크도 제공합니다."
  }, {
    "heading": "추가-감사",
    "content": "또한 다음 분들께 감사드립니다:"
  }, {
    "heading": "추가-감사",
    "content": "Rick Button님께서 npm의 turbo 패키지 이름을 기부해주신 것에 감사드립니다"
  }, {
    "heading": "추가-감사",
    "content": "Iheanyi Ekechukwu님께서 팬데믹 기간 동안 Jared가 Golang을 배우도록 도와주신 것에 감사드립니다!"
  }, {
    "heading": "추가-감사",
    "content": "Kenneth Chau님께서 Lage의 Scope 및 Pipeline API와 문서를 제공해주신 것에 감사드립니다"
  }, {
    "heading": "추가-감사",
    "content": "Miguel Oller님과 MakeSwift.com에서 Turborepo를 시범 운영해주신 것에 감사드립니다"
  }, {
    "heading": "추가-감사",
    "content": "Eric Koslow님, Jack Hanford님, 그리고 Lattice.com에서 Turborepo를 시범 운영해주신 것에 감사드립니다"
  }],
  "headings": [{
    "id": "영감과-선행-기술",
    "content": "영감과 선행 기술"
  }, {
    "id": "추가-감사",
    "content": "추가 감사"
  }]
};
export const toc = [{
  depth: 2,
  url: "#영감과-선행-기술",
  title: _jsx(_Fragment, {
    children: "영감과 선행 기술"
  })
}, {
  depth: 2,
  url: "#추가-감사",
  title: _jsx(_Fragment, {
    children: "추가 감사"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo는 원래 ", _jsx(_components.a, {
        href: "https://x.com/jaredpalmer",
        children: "Jared Palmer"
      }), "가 비공개 소스 엔터프라이즈 소프트웨어로 만들었습니다. 2021년 말, ", _jsx(_components.a, {
        href: "https://vercel.com/blog/vercel-acquires-turborepo",
        children: "Vercel이 Turborepo를 인수"
      }), "하고 코드베이스를 오픈 소스화했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["현재 Turborepo는 전담 풀타임 팀이 작업하고 있으며, 점점 늘어나는 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/graphs/contributors",
        children: "오픈 소스 기여자"
      }), " 목록을 보유하고 있습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "영감과-선행-기술",
      children: "영감과 선행 기술"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vercel.com/",
        children: "Vercel"
      }), "에서는 오픈 소스 운동과 오픈 협업의 힘을 깊이 믿고 있습니다. 이를 위해 우리와 우리의 작업에 영감을 준 프로젝트와 사람들에게 의미 있는 공로를 인정하는 것이 중요합니다."]
    }), "\n", _jsx(_components.p, {
      children: "다른 빌드 시스템, monorepo 도구 및 선행 기술에 특별히 감사드립니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Bazel - ", _jsx(_components.a, {
          href: "https://bazel.build",
          children: "https://bazel.build"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Buck - ", _jsx(_components.a, {
          href: "https://buck.build",
          children: "https://buck.build"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Please - ", _jsx(_components.a, {
          href: "https://please.build",
          children: "https://please.build"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Pants - ", _jsx(_components.a, {
          href: "https://www.pantsbuild.org",
          children: "https://www.pantsbuild.org"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Scoot - ", _jsx(_components.a, {
          href: "https://github.com/twitter/scoot",
          children: "https://github.com/twitter/scoot"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["TSDX - ", _jsx(_components.a, {
          href: "https://tsdx.io",
          children: "https://tsdx.io"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Lerna - ", _jsx(_components.a, {
          href: "https://lerna.js.org",
          children: "https://lerna.js.org"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Lage - ", _jsx(_components.a, {
          href: "https://microsoft.github.io/lage",
          children: "https://microsoft.github.io/lage"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Backfill - ", _jsx(_components.a, {
          href: "https://github.com/microsoft/backfill",
          children: "https://github.com/microsoft/backfill"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Bolt - ", _jsx(_components.a, {
          href: "https://github.com/boltpkg/bolt",
          children: "https://github.com/boltpkg/bolt"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Rush - ", _jsx(_components.a, {
          href: "https://rushjs.io",
          children: "https://rushjs.io"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Preconstruct - ", _jsx(_components.a, {
          href: "https://preconstruct.tools",
          children: "https://preconstruct.tools"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Nx - ", _jsx(_components.a, {
          href: "https://nx.dev",
          children: "https://nx.dev"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Yarn - ", _jsx(_components.a, {
          href: "https://yarnpkg.com",
          children: "https://yarnpkg.com"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["npm - ", _jsx(_components.a, {
          href: "https://www.npmjs.com",
          children: "https://www.npmjs.com"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["pnpm - ", _jsx(_components.a, {
          href: "https://pnpm.js.org",
          children: "https://pnpm.js.org"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "문서 전반에 걸쳐 해당되는 경우, 우리에게 영감을 준 프로젝트와 사람들에 대한 인라인 설명과 링크도 제공합니다."
    }), "\n", _jsx(_components.h2, {
      id: "추가-감사",
      children: "추가 감사"
    }), "\n", _jsx(_components.p, {
      children: "또한 다음 분들께 감사드립니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://x.com/rickbutton",
          children: "Rick Button"
        }), "님께서 npm의 ", _jsx(_components.code, {
          children: "turbo"
        }), " 패키지 이름을 기부해주신 것에 감사드립니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://x.com/kwuchu",
          children: "Iheanyi Ekechukwu"
        }), "님께서 팬데믹 기간 동안 Jared가 Golang을 배우도록 도와주신 것에 감사드립니다!"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://x.com/kenneth_chau",
          children: "Kenneth Chau"
        }), "님께서 Lage의 Scope 및 Pipeline API와 문서를 제공해주신 것에 감사드립니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://x.com/ollermi",
          children: "Miguel Oller"
        }), "님과 ", _jsx(_components.a, {
          href: "https://www.makeswift.com/",
          children: "MakeSwift.com"
        }), "에서 Turborepo를 시범 운영해주신 것에 감사드립니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://x.com/ekosz1",
          children: "Eric Koslow"
        }), "님, ", _jsx(_components.a, {
          href: "https://x.com/jackhanford",
          children: "Jack Hanford"
        }), "님, 그리고 ", _jsx(_components.a, {
          href: "https://lattice.com/",
          children: "Lattice.com"
        }), "에서 Turborepo를 시범 운영해주신 것에 감사드립니다"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
